/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ServerVariable } from '../../../core/models/common/ServerVariable';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends ServerVariable
 * @author eric.wittmann@gmail.com
 */
export class Oas30ServerVariable extends ServerVariable {
    public constructor(name : string) {
        super(name);
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitServerVariable(this);
    }
}
Oas30ServerVariable["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30ServerVariable";
Oas30ServerVariable["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.INamed"];




